import { useRouter } from 'next/router';
import type { FC } from 'react';

import Button from '@/components/Button';

type Props = {
  onMouseEnter: () => void;
  candidateId: number;
};

const Preview: FC<Props> = ({ onMouseEnter, candidateId }) => {
  const { query, replace } = useRouter();

  return (
    <Button
      prefixIcon="material-symbols:open-in-full"
      variant="whiteOutline"
      size="long"
      className="!px-6 !py-0.5"
      onMouseEnter={() => onMouseEnter()}
      onClick={() => {
        replace({
          query: {
            ...query,
            candidatePreviewId: candidateId.toString(),
          },
        });
      }}
    >
      Preview
    </Button>
  );
};

export default Preview;
